import { FrameName } from "../config";
import type { TileEntityWithOnUpgradeMethod } from "../TileEntity";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class BearsDenSalvageableTileEntity
	extends AbstractSalvageableTileEntity
	implements TileEntityWithOnUpgradeMethod
{
	public static readonly frameName = FrameName.BEARS_DEN;
}

export default BearsDenSalvageableTileEntity;
